import {
  CLOCK_SKEW_MESSAGE,
  SESSION_EXPIRED_MESSAGE,
  errorKind,
  errorMessage,
  isApiError,
} from '@/lib/errors'

export interface QueryErrorDescription {
  /** "Não foi possível carregar {label}." */
  message: string
  /** Segunda linha: o porquê, quando ele ajuda. */
  detail: string | null
  /** Vale oferecer "Tentar de novo" (não vale para 403/404/422/4xx). */
  showRetry: boolean
  requestId: string | null
  /** Servidor inalcançável: o banner global já explica, a seção fica curta. */
  offline: boolean
}

/**
 * O que o ``QueryErrorNotice`` mostra para o erro de uma query. Rede e
 * gateway viram só "Indisponível no momento." (o ``ApiStatusBanner`` já diz
 * que é manutenção); o resto mostra a ``errorMessage``, que já é amigável.
 */
export function describeQueryError(err: unknown, label?: string): QueryErrorDescription {
  const message = `Não foi possível carregar ${label ?? 'os dados'}.`
  const requestId = isApiError(err) ? (err.problem?.request_id ?? null) : null
  const kind = errorKind(err)
  switch (kind) {
    case 'network':
    case 'unavailable':
      return { message, detail: 'Indisponível no momento.', showRetry: true, requestId, offline: true }
    case 'clock_skew':
      return { message, detail: CLOCK_SKEW_MESSAGE, showRetry: true, requestId, offline: false }
    case 'auth':
      return { message, detail: SESSION_EXPIRED_MESSAGE, showRetry: true, requestId, offline: false }
    default: {
      const showRetry =
        kind !== 'forbidden' && kind !== 'not_found' && kind !== 'validation' && kind !== 'client'
      return { message, detail: errorMessage(err, '') || null, showRetry, requestId, offline: false }
    }
  }
}
